import { Component, OnInit } from '@angular/core';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { AccountConfigurationComponent } from '../account-configuration/account-configuration.component';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';

@Component({
  selector: 'app-account-history',
  templateUrl: './account-history.component.html',
  styleUrls: ['./account-history.component.css']
,
  standalone: false
})
export class AccountHistoryComponent implements OnInit {

  accountHistory: any;

  constructor(
    public restService: RestService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AccountHistoryComponent>,
    public spinner: SpinnerService
  ) {}

  ngOnInit(): void {
    this.getHistory();
  }

  getHistory() {
    this.spinner.activate();
    let url = `${AppSettings.ACCOUNTS_HISTORY}`;
    this.restService.getRequest(url, '').subscribe(
      (response) => {
        if (response.data && response.data.length) {
          this.accountHistory = response.data.sort((a, b) => {
            const dateA = new Date(a.lastModifiedDate);
            const dateB = new Date(b.lastModifiedDate);
            return dateB.getTime() - dateA.getTime();
          });
        } else {
          this.accountHistory = [];
        }
        this.spinner.deactivate();
      },
      (error) => {
        this.spinner.deactivate();
      }
    );
  }

  formatdate(dateTimeString: string): string {
    const dateObj = new Date(dateTimeString);
    const dd = String(dateObj.getDate()).padStart(2, '0');
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const yyyy = dateObj.getFullYear();
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    return `${mm}-${dd}-${yyyy}  ${hours}:${minutes}:${seconds}`;
  }

  closeAndNavigate() {
    this.spinner.activate();
    this.dialogRef.close();
    this.spinner.deactivate();
    this.navigateAccountConfiguration();
  }

  navigateAccountConfiguration() {
    this.spinner.activate();
    this.dialog.open(AccountConfigurationComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '90vw',
      panelClass: 'centered-modal',
    }).afterClosed().subscribe(()=>{
      this.spinner.deactivate();
    });
  }

}
